import { ProductQueryParam, SearchMaskGroupType, SearchMaskInputType, } from '../../../globalTypes';
import { settings } from '../../../settings';
var Tui6MFlightRouter = /** @class */ (function () {
    function Tui6MFlightRouter() {
    }
    Tui6MFlightRouter.fillTravelPeriod = function (searchMaskGroup, params) {
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD];
        if (searchMaskInput && searchMaskInput.coreQuery) {
            var departureDate = searchMaskInput.coreQuery[ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_DATE];
            if (departureDate) {
                params.append('depDate', departureDate);
            }
            var returnDate = searchMaskInput.coreQuery[ProductQueryParam.TRAVEL_PERIOD_RETURN_DATE];
            if (returnDate) {
                params.append('retDate', returnDate);
            }
        }
    };
    Tui6MFlightRouter.fillDepartureAirports = function (searchMaskGroup, params) {
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.DEPARTURE_AIRPORT];
        Tui6MFlightRouter.fillAirports(params, searchMaskInput, 'origin');
    };
    Tui6MFlightRouter.fillArrivalAirports = function (searchMaskGroup, params) {
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.ARRIVAL_AIRPORT];
        Tui6MFlightRouter.fillAirports(params, searchMaskInput, 'destination');
    };
    Tui6MFlightRouter.fillAirports = function (params, searchMaskInput, paramName) {
        if (searchMaskInput && searchMaskInput.confirmedValue && searchMaskInput.confirmedValue.value) {
            if (Array.isArray(searchMaskInput.confirmedValue.value) && searchMaskInput.confirmedValue.value.length > 0) {
                var airportCodes_1 = [];
                var values = searchMaskInput.confirmedValue.value;
                values.forEach(function (value) {
                    if (value.airports) {
                        // Airport group
                        value.airports.forEach(function (airports) {
                            if (Array.isArray(airports)) {
                                airports.forEach(function (airport) {
                                    airportCodes_1.push(airport.code);
                                });
                            }
                            else {
                                airportCodes_1.push(airports.code);
                            }
                        });
                    }
                    else {
                        // Airport
                        airportCodes_1.push(value.code);
                    }
                });
                //@ts-ignore
                var airportCodesParam = airportCodes_1.join(',');
                params.append(paramName, airportCodesParam);
            }
        }
    };
    Tui6MFlightRouter.fillTravellers = function (searchMaskGroup, params) {
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.TRAVELLERS];
        if (searchMaskInput && searchMaskInput.coreQuery) {
            var adults = searchMaskInput.coreQuery[ProductQueryParam.TRAVELLERS_ADULTS];
            if (adults) {
                params.append('adult', '' + adults);
            }
            var children = searchMaskInput.coreQuery[ProductQueryParam.TRAVELLERS_CHILDREN_AGE];
            var childCount_1 = 0;
            var infantCount_1 = 0;
            if (children && Array.isArray(children) && children.length > 0) {
                children.forEach(function (child) {
                    if (child >= 2) {
                        childCount_1 += 1;
                    }
                    else {
                        infantCount_1 += 1;
                    }
                });
            }
            params.append('child', childCount_1.toString());
            params.append('infant', infantCount_1.toString());
        }
    };
    Tui6MFlightRouter.generate = function (lturState) {
        var result = '';
        if (lturState.websiteState &&
            lturState.websiteState.searchMask &&
            lturState.websiteState.searchMask.searchMaskBundle &&
            lturState.websiteState.searchMask.searchMaskBundle.groups
            && lturState.websiteState.searchMask.searchMaskBundle.groups[SearchMaskGroupType.FLIGHT]) {
            var baseUrl = settings.flightRouter.tui6MFlightBaseUrl;
            var reBase = /^(https?:)?\/\//i;
            if (!baseUrl.match(reBase)) {
                var windowLocation = window.location;
                baseUrl = windowLocation.protocol + '//' + windowLocation.host + baseUrl;
            }
            var url = new URL(baseUrl);
            var params = url.searchParams;
            params.append('journeyType', 'ROUNDTRIP');
            var searchMaskGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[SearchMaskGroupType.FLIGHT];
            Tui6MFlightRouter.fillTravelPeriod(searchMaskGroup, params);
            Tui6MFlightRouter.fillDepartureAirports(searchMaskGroup, params);
            Tui6MFlightRouter.fillArrivalAirports(searchMaskGroup, params);
            Tui6MFlightRouter.fillTravellers(searchMaskGroup, params);
            params.append('searchin', 'DE-SB-FL');
            result = url.href;
        }
        return result;
    };
    return Tui6MFlightRouter;
}());
export { Tui6MFlightRouter };
export default Tui6MFlightRouter;
